/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useRef, useEffect } from 'react'
import {
  View,
  Dimensions,
  StatusBar,
  Platform,
  Animated,
  TouchableWithoutFeedback,
  Pressable,
  ScrollView,
} from 'react-native'
import PropTypes from 'prop-types'
import { selectContactPhone } from 'react-native-select-contact'
import {
  check,
  request,
  openSettings,
  PERMISSIONS,
  RESULTS,
} from 'react-native-permissions'
import {
  Icon,
  QuickActionMenu,
  VFInput,
  VFButton,
} from '@vfgroup-oneplatform/foundation/Components'
import { Colors, withTheme, useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import VfText from '../../Components/VfText'
import ButtonGroup from '../../Components/ButtonGroup'
import HorizontalLine from '../../Components/HorizontalLine'
import ProgressBar from '../../Components/ProgressBar'
import WheelSelector from '../../Components/WheelSelector'
import MigrationLottie from '../../Components/MigrationLottie'
import PaymentOptions from '../../Components/PaymentOptions'

import images from '../../Themes/Images'

import { getThemeColors, getThemeImages } from '../../Themes/Modes'

import styles from './DataSharing.Styles'

import Modal from 'react-native-modal'
import SmoothPicker from 'react-native-smooth-picker';


const { width, height: SCREEN_HEIGHT } = Dimensions.get('window')

const contentTypes = {
  internet: 'internet',
  vcoins: 'vcoins',
  balance: 'balance',
  minutes: 'minutes',
}

const activeScreens = {
  home: 'home',
  payment: 'payment',
  confirm: 'confirm',
  error: 'error',
  success: 'success',
  loading: 'loading',
}

const screenTextTypes = {
  internet: {
    title: 'share_internet_subtitle',
    confirmationDesc: 'share_internet_label',
  },
  vcoins: {
    title: 'share_coins_subtitle',
    confirmationDesc: 'share_vcoins_label',
  },
  balance: {
    title: 'share_balance_subtitle',
    confirmationDesc: 'share_balance_label',
  },
  minutes: {
    title: 'share_minutes_subtitle',
    confirmationDesc: 'share_minutes_label',
  },
}

const cLoaderColors = {
  background: '#f3f3f3',
  foreground: '#ecebeb',
}

const outputRange = [0.6, 0.8, 1, 0.8, 0.6]

const opacityRange = [0.3, 0.5, 1, 0.5, 0.3]

const translateYRange = [0, 0, 0, 0, 0]

const translateXRange = [-30, -10, 0, 10, 30]
const opacities = {
  0: 1,
  1: 0.5,
  2: 0.5,
  3: 0.3,
  4: 0.3,
};
const sizeText = {
  0: 20,
  1: 15,
  2: 10,
};

const Item = React.memo(({ opacity, selected, vertical, fontSize, item }) => {
  const theme = useTheme()
  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <View
        style={[
          styles.OptionWrapper,
          {
            opacity,
            width: vertical ? itemWidth : 'auto',
          },
        ]}>
        <View style={styles.itemContent} >
          {item?.icon && <Icon
            name={images.vcoins_grey}
            size={20}
            type="image"
            resizeMode="contain"
            style={{ marginRight: 5, marginBottom: 12 }}
          />}
          <View style={styles.itemTextsWrapper}>
            <VfText color={theme.colors.textColor} i18nKey={item?.title} weight={item?.extraData ? "regular" : "bold"} size={selected ? 'h1' : "h4"} style={{ marginTop: 20 }} />
            {item?.extraData && <VfText i18nKey={'+' + item?.extraData} weight="bold" size="h3" color={Colors.vfRed} style={{ fontSize: selected ? 32 : 24 }} />}
            {item?.description && <VfText color={theme.colors.textColor} i18nKey={item?.description} size={selected ? 'h3' : "footnote"} style={{ fontSize: selected ? 24 : 14 }} />}
          </View>
        </View>
      </View>
    );
  }
  return (
    <View
      style={[
        styles.OptionWrapper,
        {
          opacity,
          width: vertical ? itemWidth : 'auto',
        },
      ]}>
      <View style={styles.itemContent} >
        {item?.icon && <Icon
          name={images.vcoins_grey}
          size={20}
          type="image"
          resizeMode="contain"
          style={{ marginRight: 5, marginBottom: 12 }}
        />}
        <View style={styles.itemTextsWrapper}>
          <VfText color={theme.colors.textColor} i18nKey={item?.title} weight={item?.extraData ? "regular" : "bold"} size="h4" />
          {item?.extraData && <VfText i18nKey={'+' + item?.extraData} weight="bold" size="h3" color={Colors.vfRed} style={{ lineHeight: 24 }} />}
          {item?.description && <VfText color={theme.colors.textColor} i18nKey={item?.description} size="footnote" style={{ lineHeight: 14 }} />}
        </View>
      </View>
    </View>
  );
});

const ItemToRender = ({ item, index }, handleChange, indexSelected, vertical) => {
  const selected = index === indexSelected;
  const gap = Math.abs(index - indexSelected);
  let opacity = opacities[gap];
  if (gap > 3) {
    opacity = opacities[4];
  }
  let fontSize = sizeText[gap];
  if (gap > 1) {
    fontSize = sizeText[2];
  }

  return (
    <Item
      opacity={opacity}
      selected={selected}
      vertical={vertical}
      fontSize={fontSize}
      item={item}
    />
  );
};

function DataContent({
  entries = [],
  selected,
  setSelected,
  scrollY,
  carouselRef,
  monthlyLimit,
  theme,
}) {

  const themeImages = getThemeImages(theme.name)

  const [selectedIndex, setSelectedIndex] = useState(0);
  function handleChange(index) {
    setSelectedIndex(index)
    setSelected(index);
  }

  const opacities = {
    0: 1,
    1: 0.5,
    2: 0.5,
    3: 0.3,
    4: 0.3,
  };
  const sizeText = {
    0: 20,
    1: 15,
    2: 10,
  };

  let itemWidth = width / 5
  if (entries?.length <= 4) {
    itemWidth = width / 3
  }
  const getInputRange = index => {
    const w = itemWidth
    const prev2 = (index - 2) * w
    const prev1 = (index - 1) * w
    const next1 = (index + 1) * w
    const next2 = (index + 2) * w
    return [prev2, prev1, index * w, next1, next2]
  }

  const handleItemPress = (index) => {
    setSelected(index);
    if (carouselRef.current) {
      carouselRef.current.scrollToIndex({ index, animated: true, viewPosition: 0.5 })
    }
  }

  const renderItem = ({
    item, index,
  }) => (
    <TouchableWithoutFeedback key={item?.id} onPress={() => handleItemPress(index)}>
      <Animated.View
        style={[
          styles.item,
          {
            opacity: scrollY.interpolate({
              inputRange: getInputRange(index),
              outputRange: opacityRange,
              extrapolate: 'clamp',
            }),
            transform: [
              {
                scale: scrollY.interpolate({
                  inputRange: getInputRange(index),
                  outputRange: outputRange,
                  extrapolate: 'clamp',
                }),
              },
              {
                translateY: scrollY.interpolate({
                  inputRange: getInputRange(index),
                  outputRange: translateYRange,
                  extrapolate: 'clamp',
                }),
              },
              {
                translateX: scrollY.interpolate({
                  inputRange: getInputRange(index),
                  outputRange: translateXRange,
                  extrapolate: 'clamp',
                }),
              },
            ],
          },
          {
            width: itemWidth,
          },
        ]}
      >
        <View style={styles.itemContent}>
          {item?.icon && <Icon
            name={themeImages.vcoins}
            size={20}
            type="image"
            resizeMode="contain"
            style={{ marginRight: 5, marginBottom: 12 }}
          />}
          <View style={styles.itemTextsWrapper}>
            <VfText
              i18nKey={item?.title}
              weight={item?.extraData ? "regular" : "bold"}
              size="h4"
              // color={theme.colors.textColor}
              color={theme.colors.textColor}
            />
            {item?.extraData && <VfText
              i18nKey={'+' + item?.extraData}
              weight="bold" size="h3"
              // color={Colors.vfRed}
              color={theme.colors.textColor}
              style={{ lineHeight: 24 }}
            />}
            {item?.description && <VfText
              i18nKey={item?.description}
              size="footnote"
              style={{ lineHeight: 14 }}
              // color={theme.colors.textColor}
              color={theme.colors.textColor}
            />}
          </View>
        </View>
      </Animated.View>
    </TouchableWithoutFeedback>
  )

  return (
    <>
      <VfText
        size="h3"
        weight="light"
        i18nKey="share_label_choose_transfer"
        style={{ marginBottom: 30, marginTop: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 30 : null }}
        loadingBackgroundColor={cLoaderColors.background}
        loadingForegroundColor={cLoaderColors.foreground}
        color={theme.colors.textColor}
      // color={theme.colors.textColor}
      />
      {Platform.OS === 'web' ?
        <View style={styles.smothPickerHorizontalContainer}>
          <View style={styles.smothPickerHorizontalWrapper}>
            <SmoothPicker
              horizontal
              initialScrollToIndex={selectedIndex}
              onScrollToIndexFailed={() => { }}
              keyExtractor={(_, index) => index.toString()}
              showsHorizontalScrollIndicator={false}
              data={entries}
              snapToAlignment='start'
              scrollAnimation
              onSelected={({ item, index }) => handleChange(index)}
              renderItem={(option) => ItemToRender(option, handleChange, selectedIndex, false)}
              magnet
              selectOnPress
              startMargin={25}
              endMargin={25}
            />
          </View>
        </View>
        :
        <WheelSelector
          entries={entries}
          setSelected={setSelected}
          scrollY={scrollY}
          renderItem={renderItem}
          carouselRef={carouselRef}
        />}

      {monthlyLimit?.map((limit) => {
        return (<ProgressBar
          description={limit?.description}
          usedData={limit?.used}
          limit={limit?.limit}
          type={limit?.type}
          backgroundColor={Colors.tangerine}
          foregroundColor={Colors.ocean}
          desc={limit?.reachedDescription}
          theme={theme}
        />)
      })}
    </>
  )
}
DataContent.propTypes = {
  entries: PropTypes.array,
  selected: PropTypes.string,
  setSelected: PropTypes.func,
  scrollY: PropTypes.number,
  carouselRef: PropTypes.object,
  monthlyLimit: PropTypes.object,
  contentType: PropTypes.string,
}

function Home({
  contentType,
  changeContentType,
  inputRef,
  selectContact,
  phoneNumber,
  setPhoneNumber,
  setActiveScreen,
  shareOptions,
  entries,
  selected,
  setSelected,
  scrollY,
  carouselRef,
  isPhoneNumberError,
  setPhoneNumberError,
  checkPhoneNumber,
  monthlyLimit,
  theme,
  validatePhoneNumber,
  setIsModalVisible
}) {

  const themeImages = getThemeImages(theme?.name)

  return (
    <ScrollView contentContainerStyle={{ paddingBottom: Platform.OS == 'web' && Dimensions.get('window').width > 700 ? 70 : 0 }}>
      <View style={styles.subHeaderContainer}>
        <VfText
          size="h3"
          weight="light"
          i18nKey={screenTextTypes?.[contentType]?.title}
          // isLoading={offerLoading}
          style={styles.title(theme)}
          loadingBackgroundColor={cLoaderColors.background}
          loadingForegroundColor={cLoaderColors.foreground}
        />
      </View>
      <ButtonGroup
        selected={contentType}
        onPress={changeContentType}
        options={shareOptions}
        theme={theme}
      />
      {!entries?.length || entries?.length <= 0 ?
        <VfText
          size="h3"
          weight="light"
          i18nKey="share_no_transfer_options"
          style={styles.noOptionText(theme)}
          loadingBackgroundColor={cLoaderColors.background}
          loadingForegroundColor={cLoaderColors.foreground}
        />
        :
        <>
          <VFInput
            fontSize={18}
            fieldRef={ref => {
              inputRef.current = ref
            }}
            baseColor={isPhoneNumberError ? theme.colors.textInput.error.baseColor : theme.colors.textInput.default.baseColor}
            label="top_up_someone_else_new_recipient_header_title"
            showRightIcon={false}
            rightIconName={isPhoneNumberError ? themeImages.warning : themeImages.contact}
            rightIconType="image"
            rightIconStyle={styles.icon}
            rightIconPress={selectContact}
            value={phoneNumber}
            onChangeText={setPhoneNumber}
            containerStyle={styles.inputContainer}
            labelTextStyle={styles.inputText(theme)}
            style={styles.inputText(theme)}
            tintColor={getThemeColors(theme.name).tintColor}
            keyboardType="phone-pad"
            onBlur={() => checkPhoneNumber()}
            onFocus={() => setPhoneNumberError(false)}
            showHelperText={isPhoneNumberError}
            helperTextColor={theme.colors.textInput.error.helperText}
            helperText="share_wrong_phone_format"
          />
          {/* <HorizontalLine style={styles.separator(theme)} /> */}
          <DataContent
            entries={entries}
            selected={selected}
            setSelected={setSelected}
            scrollY={scrollY}
            carouselRef={carouselRef}
            monthlyLimit={monthlyLimit}
            contentType={contentType}
            theme={theme}
          />
          <VFButton
            type="primary"
            title="share_transfer_button"
            onPress={() => {
              if (!isPhoneNumberError) {
                if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
                  setIsModalVisible(true)
                } else {
                  setActiveScreen(activeScreens.confirm)
                }
              }
            }}
            style={styles.button}
            disabled={!phoneNumber || !validatePhoneNumber(phoneNumber)}
            isLoading={false}
            disabledStyle={styles.disabledStyle(theme)}
          // loadingTitle="refill_button_continue"
          />
        </>}
    </ScrollView>
  )
}
Home.propTypes = {
  contentType: PropTypes.string,
  setContentType: PropTypes.func,
  changeContentType: PropTypes.func,
  inputRef: PropTypes.object,
  selectContact: PropTypes.func,
  phoneNumber: PropTypes.string,
  setPhoneNumber: PropTypes.func,
  ContentType: PropTypes.node,
  setActiveScreen: PropTypes.func,
  isPhoneNumberError: PropTypes.bool,
  setPhoneNumberError: PropTypes.func,
  checkPhoneNumber: PropTypes.func,
  shareOptions: PropTypes.array,
  entries: PropTypes.array,
  selected: PropTypes.string,
  setSelected: PropTypes.func,
  scrollY: PropTypes.number,
  carouselRef: PropTypes.object,
  monthlyLimit: PropTypes.object,
  theme: PropTypes.object,
  validatePhoneNumber: PropTypes.func,
}

function Loading() {
  return (
    <View
      style={styles.modal}
      onStartShouldSetResponder={() => true}
    >
      <View style={styles.modalContentWraper}>
        <MigrationLottie
          source={require('./loaderE60000.json')}
          style={styles.lottie}
        />
      </View>
    </View>
  )
}
Loading.propTypes = {
}

function Success({
  isContentLoading,
  dismissModal,
  theme,
}) {
  return (
    <View
      style={styles.modal}
      onStartShouldSetResponder={() => true}
    >
      <View style={styles.modalContentWraper}>
        <Icon
          name={images.tick}
          size={95}
          type="image"
          resizeMode="contain"
        />
        <VfText
          weight="light"
          size="h3"
          align="center"
          style={styles.verticalSpacing}
          isLoading={isContentLoading}
          i18nKey="share_label_success"
          loadingBackgroundColor={cLoaderColors.background}
          loadingForegroundColor={cLoaderColors.foreground}
          color={theme.colors.textColor}
        />
      </View>
      <VFButton
        type="primary"
        title="share_button_close"
        onPress={() => dismissModal()}
      />
    </View>
  )
}
Success.propTypes = {
  isContentLoading: PropTypes.bool,
  dismissModal: PropTypes.func,
  theme: PropTypes.object,
}

function Confirm({
  setActiveScreen,
  contentType,
  phoneNumber,
  selected,
  transfer,
  confirmationText,
  theme,
  setIsModalVisible
}) {

  return (
    <View
      style={styles.modal}
      onStartShouldSetResponder={() => true}>
      <View style={styles.subHeaderContainer}>
        <VfText
          size="h3"
          weight="light"
          i18nKey="share_confirm_message"
          placeHolders={[selected?.subtitle, phoneNumber]}
          // isLoading={offerLoading}
          style={styles.title}
          loadingBackgroundColor={cLoaderColors.background}
          loadingForegroundColor={cLoaderColors.foreground}
          color={theme.colors.textColor}
        />
      </View>

      <VfText
        size="footnote"
        weight="light"
        i18nKey={confirmationText?.[contentType]}
        // isLoading={offerLoading}
        style={styles.subtitle}
        loadingBackgroundColor={cLoaderColors.background}
        loadingForegroundColor={cLoaderColors.foreground}
        color={theme.colors.textColor}
      />

      <VFButton
        type="primary"
        title="share_button_confirm"
        onPress={transfer}
        style={styles.confirmButton}
      />
      <VFButton
        type="secondary"
        title="share_button_go_back"
        onPress={() => {
          if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
            setIsModalVisible(false)
          } else {
            setActiveScreen(activeScreens.home)
          }
        }}
      />
    </View>
  )
}
Confirm.propTypes = {
  setActiveScreen: PropTypes.func,
  contentType: PropTypes.string,
  phoneNumber: PropTypes.string,
  selected: PropTypes.object,
  transfer: PropTypes.func,
  confirmationText: PropTypes.object,
  theme: PropTypes.object,
}

function Payment({
  paymentOptions,
  setActiveScreen,
  theme,
}) {
  return (
    <View
      style={styles.modal}
      onStartShouldSetResponder={() => true}
    >
      <View style={styles.subHeaderContainer}>
        <VfText
          size="h3"
          weight="light"
          i18nKey="share_pay_with"
          // isLoading={offerLoading}
          style={styles.title}
          loadingBackgroundColor={cLoaderColors.background}
          loadingForegroundColor={cLoaderColors.foreground}
          color={theme.colors.textColor}
        />
      </View>
      <PaymentOptions
        options={paymentOptions}
        onOptionPress={() => setActiveScreen(activeScreens.confirm)}
        theme={theme}
      />
    </View>
  )
}
Payment.defaultProps = {
  paymentOptions: [
    {
      id: '1',
      name: 'share_payment_type_bill',
      icon: images.bill,
    },
    {
      id: '2',
      name: 'share_payment_type_balance',
      icon: images.coins,
    },
  ],
}
Payment.propTypes = {
  paymentOptions: PropTypes.array,
  setActiveScreen: PropTypes.func,
  theme: PropTypes.object,
}

function ErrorStep({
  activationLoading,
  isContentLoading,
  setActiveScreen,
  offerLoading,
  error,
  setPhoneNumber,
  theme,
  setModalStep,
  setIsModalActive,
  setIsModalVisible,
}) {

  const goBack = () => {
    if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
      setPhoneNumber('')
      setModalStep(activeScreens.confirm)
      setIsModalActive(false)
    } else {
      setPhoneNumber('')
      setActiveScreen(activeScreens.home)
    }
  }

  return (
    <View
      style={styles.modal}
      onStartShouldSetResponder={() => true}
    >
      <View style={styles.modalContentWraper}>
        <Icon
          name={images.error}
          size={95}
          type="image"
          resizeMode="contain"
        />
        <VfText
          weight="bold"
          size="h3"
          align="center"
          style={styles.verticalSpacing}
          isLoading={isContentLoading}
          i18nKey="share_label_problem"
          loadingBackgroundColor={cLoaderColors.background}
          loadingForegroundColor={cLoaderColors.foreground}
          color={theme.colors.textColor}
        />
        <VfText
          align="center"
          isLoading={activationLoading || offerLoading}
          i18nKey={error || 'Error'}
          loadingBackgroundColor={cLoaderColors.background}
          loadingForegroundColor={cLoaderColors.foreground}
          color={theme.colors.textColor}
        />
      </View>
      <VFButton
        type="primary"
        title="share_button_go_back"
        onPress={goBack}
      />
    </View>
  )
}
ErrorStep.propTypes = {
  activationLoading: PropTypes.bool,
  isContentLoading: PropTypes.bool,
  setActiveScreen: PropTypes.func,
  offerLoading: PropTypes.bool,
  error: PropTypes.string,
  setPhoneNumber: PropTypes.func,
  theme: PropTypes.object,
}

const ActiveScreen = {
  home: Home,
  payment: Payment,
  confirm: Confirm,
  error: ErrorStep,
  success: Success,
  loading: Loading,
}

function DataSharing({
  loading,
  isVisible,
  toggleModal,
  dataOptions,
  balanceOptions,
  vcoinsOptions,
  transferBalance,
  transferData,
  transferVcoins,
  entryData,
  monthlyLimit,
  preselectedOption,
  confirmationText,
  theme,
  validatePhoneNumber,
  formatPhoneNumber,
}) {

  const [activeScreen, changeActiveScreen] = useState(activeScreens.home)
  const ShareStep = loading ? ActiveScreen.loading : ActiveScreen[activeScreen]
  const [modalStep, setModalStep] = useState(activeScreens.confirm)
  const ModalStep = ActiveScreen[modalStep]
  const [isModalVisible, setIsModalVisible] = useState(false)
  const [contentType, setContentType] = useState(preselectedOption)
  const [error, setError] = useState('')

  const scrollY = useRef(new Animated.Value(0)).current
  const carouselRef = useRef(null)

  const [phoneNumber, setPhoneNumber] = useState('')
  const [paymentOptions, setPaymentOptions] = useState([
    {
      id: 1,
      name: 'share_payment_type_bill',
      icon: images.bill,
    },
    {
      id: 2,
      name: 'share_payment_type_balance',
      icon: images.coins,
    },
  ])
  const [shareOptions, setShareOptions] = useState([])

  const [selected, setSelected] = useState(0)
  const [entries, setEntries] = useState([])

  const inputRef = useRef()

  const [isPhoneNumberError, setPhoneNumberError] = useState(false)

  const checkPhoneNumber = () => {
    if (phoneNumber && !validatePhoneNumber(phoneNumber)) {
      setPhoneNumberError(true)
    } else {
      setPhoneNumberError(false)
    }
  }

  const [height, setHeight] = useState(SCREEN_HEIGHT * 0.8 - 32)

  const changeheight = event => {
    const { height: contentHeight } = event.layout
    if (contentHeight < height) {
      setHeight(contentHeight)
    }
  }

  const selectFromContacts = () => {
    selectContactPhone().then(selection => {
      if (!selection) {
        return
      }
      inputRef.current?.setValue(formatPhoneNumber(selection.selectedPhone?.number))
      setPhoneNumber(formatPhoneNumber(selection.selectedPhone?.number))
      setPhoneNumberError(false)
      return
    })
  }

  const selectContact = () => {
    const permission = Platform.select({
      ios: PERMISSIONS.IOS.CONTACTS,
      android: PERMISSIONS.ANDROID.READ_CONTACTS,
    })
    check(permission)
      .then(result => {
        switch (result) {
          case RESULTS.UNAVAILABLE:
            break
          case RESULTS.DENIED:
            request(permission)
              .then((res) => {
                if (res === RESULTS.GRANTED) {
                  selectFromContacts()
                }
              })
              .catch(() => { })
            break
          case RESULTS.GRANTED:
            selectFromContacts()
            break
          case RESULTS.BLOCKED:
            openSettings().catch(() => null)
            break
        }
      })
      .catch(() => null)
  }

  const changeContentType = screen => {
    inputRef.current?.setValue('')
    setPhoneNumber('')
    setSelected(0)
    carouselRef?.current?.scrollToOffset({ animated: true, x: 0 })
    setContentType(screen)
  }

  const dismissModal = () => {
    toggleModal()
    changeActiveScreen(activeScreens.home)
  }

  const closeModal = () => {
    if (activeScreen === 'payment') {
      changeActiveScreen(activeScreens.home)
    } else {
      dismissModal()
    }
  }

  useEffect(() => {
    if (entryData) {
      setEntries(entryData[contentType])
      const ShareOptions = []
      if (entryData.internet.length !== 0) {
        ShareOptions.push({
          image: images.mobileData,
          screenName: contentTypes.internet,
          disabled: Boolean(dataOptions?.items?.length <= 0),
        })
      }
      if (entryData.balance.length !== 0) {
        ShareOptions.push({
          image: images.balance,
          screenName: contentTypes.balance,
          disabled: Boolean(balanceOptions?.items?.length <= 0),
        })
      }
      if (entryData.vcoins.length !== 0) {
        ShareOptions.push({
          image: images.vcoins_white,
          screenName: contentTypes.vcoins,
          disabled: Boolean(vcoinsOptions?.items?.length <= 0),
        })
      }
      if (entryData.minutes.length !== 0) {
        ShareOptions.push({
          image: images.call,
          screenName: contentTypes.minutes,
        })
      }
      setShareOptions(ShareOptions)
    }
  }, [contentType, entryData])

  const setActiveScreen = (screen, errorMessage = '') => {
    changeActiveScreen(screen)
    setError(errorMessage)
  }

  useEffect(() => {
    setContentType(preselectedOption)
  }, [loading])

  const transfer = () => {
    const receiverNumber = formatPhoneNumber(phoneNumber)

    setActiveScreen(activeScreens.loading)
    const selectedOption = entries?.[selected]
    if (contentType === 'internet') {
      transferData({ ...selectedOption, receiver: receiverNumber }, {
        onSuccess: () => {
          setPhoneNumber('')
          setActiveScreen(activeScreens.success)
        },
        onError: (er) => {
          setPhoneNumber('')
          setActiveScreen(activeScreens.error, er)
        },
      })
    } else if (contentType === 'vcoins') {
      transferVcoins({ ...selectedOption, receiver: receiverNumber }, {
        onSuccess: () => {
          setPhoneNumber('')
          setActiveScreen(activeScreens.success)
        },
        onError: (er) => {
          setPhoneNumber('')
          setActiveScreen(activeScreens.error, er)
        },
      })
    } else {
      transferBalance({ ...selectedOption, receiver: receiverNumber }, {
        onSuccess: () => {
          setPhoneNumber('')
          setActiveScreen(activeScreens.success)
        },
        onError: (er) => {
          setPhoneNumber('')
          setActiveScreen(activeScreens.error, er)
        },
      })
    }
  }

  const transferModal = () => {
    const receiverNumber = formatPhoneNumber(phoneNumber)

    setModalStep(activeScreens.loading)
    const selectedOption = entries?.[selected]
    if (contentType === 'internet') {
      transferData({ ...selectedOption, receiver: receiverNumber }, {
        onSuccess: () => {
          setPhoneNumber('')
          setModalStep(activeScreens.success)
        },
        onError: (er) => {
          setPhoneNumber('')
          setModalStep(activeScreens.error, er)
        },
      })
    } else if (contentType === 'vcoins') {
      transferVcoins({ ...selectedOption, receiver: receiverNumber }, {
        onSuccess: () => {
          setPhoneNumber('')
          setModalStep(activeScreens.success)
        },
        onError: (er) => {
          setPhoneNumber('')
          setModalStep(activeScreens.error, er)
        },
      })
    } else {
      transferBalance({ ...selectedOption, receiver: receiverNumber }, {
        onSuccess: () => {
          setPhoneNumber('')
          setModalStep(activeScreens.success)
        },
        onError: (er) => {
          setPhoneNumber('')
          setModalStep(activeScreens.error, er)
        },
      })
    }
  }

  if (width > 700 && Platform.OS === 'web') {
    return (
      <View
        style={styles.shareWrapper}
        onLayout={({ nativeEvent }) => changeheight(nativeEvent)}
        onStartShouldSetResponder={() => true}
      >
        <ShareStep
          phoneNumber={phoneNumber}
          setPhoneNumber={setPhoneNumber}
          activeScreen={activeScreen}
          setActiveScreen={setActiveScreen}
          changeContentType={changeContentType}
          selectContact={selectContact}
          inputRef={inputRef}
          contentType={contentType}
          setContentType={setContentType}
          isPhoneNumberError={isPhoneNumberError}
          setPhoneNumberError={setPhoneNumberError}
          checkPhoneNumber={checkPhoneNumber}
          paymentOptions={paymentOptions}
          setPaymentOptions={setPaymentOptions}
          shareOptions={shareOptions}
          entries={entries}
          selected={entries?.[selected]}
          setSelected={setSelected}
          scrollY={scrollY}
          carouselRef={carouselRef}
          dismissModal={dismissModal}
          transfer={transfer}
          monthlyLimit={monthlyLimit[contentType]}
          error={error}
          confirmationText={confirmationText}
          setIsModalVisible={setIsModalVisible}
          theme={theme}
          validatePhoneNumber={validatePhoneNumber}
        />
        <Modal
          isVisible={isModalVisible}
          backdropOpacity={0.5}
          onSwipeComplete={() => close()}
          onBackdropPress={() => close()}
          propagateSwipe
          hideModalContentWhileAnimating
          hardwareAccelerated
          backdropTransitionOutTiming={0}
          style={{
            justifyContent: 'flex-end',
            margin: '0 !important',
            minWidth: 1920,
            maxWidth: 1920,
          }}
        >
          <View
            style={{
              height: 'auto',
              minWidth: '600px',
              maxWidth: '600px',
              backgroundColor: theme.colors.quickActionGradientColors.secondary,
              margin: 'auto',
              padding: '20px',
              borderRadius: "7px",
            }}
            onStartShouldSetResponder={() => true}>
            <ModalStep
              phoneNumber={phoneNumber}
              setPhoneNumber={setPhoneNumber}
              activeScreen={activeScreen}
              setActiveScreen={setActiveScreen}
              changeContentType={changeContentType}
              selectContact={selectContact}
              inputRef={inputRef}
              contentType={contentType}
              setContentType={setContentType}
              isPhoneNumberError={isPhoneNumberError}
              setPhoneNumberError={setPhoneNumberError}
              checkPhoneNumber={checkPhoneNumber}
              paymentOptions={paymentOptions}
              setPaymentOptions={setPaymentOptions}
              shareOptions={shareOptions}
              entries={entries}
              selected={entries?.[selected]}
              setSelected={setSelected}
              scrollY={scrollY}
              carouselRef={carouselRef}
              dismissModal={dismissModal}
              transfer={transferModal}
              monthlyLimit={monthlyLimit[contentType]}
              error={error}
              confirmationText={confirmationText}
              setIsModalVisible={setIsModalVisible}
              setModalStep={setModalStep}
              theme={theme}
              setIsModalActive={setIsModalVisible}
            />
          </View>
        </Modal>
      </View>
    )
  }

  return (
    <QuickActionMenu
      isVisible={isVisible}
      toggleModal={closeModal}
      type="secondary"
      title="share_title"
      titleStyle={styles.titleStyle}
      closeBtnStyle={styles.closeBtnStyle}
    >
      <View
        style={styles.modal}
        onLayout={({ nativeEvent }) => changeheight(nativeEvent)}
        onStartShouldSetResponder={() => true}
      >
        <ShareStep
          phoneNumber={phoneNumber}
          setPhoneNumber={setPhoneNumber}
          activeScreen={activeScreen}
          setActiveScreen={setActiveScreen}
          changeContentType={changeContentType}
          selectContact={selectContact}
          inputRef={inputRef}
          contentType={contentType}
          setContentType={setContentType}
          isPhoneNumberError={isPhoneNumberError}
          setPhoneNumberError={setPhoneNumberError}
          checkPhoneNumber={checkPhoneNumber}
          paymentOptions={paymentOptions}
          setPaymentOptions={setPaymentOptions}
          shareOptions={shareOptions}
          entries={entries}
          selected={entries?.[selected]}
          setSelected={setSelected}
          scrollY={scrollY}
          carouselRef={carouselRef}
          dismissModal={dismissModal}
          transfer={transfer}
          monthlyLimit={monthlyLimit[contentType]}
          error={error}
          confirmationText={confirmationText}
          theme={theme}
          validatePhoneNumber={validatePhoneNumber}
        />
      </View>
    </QuickActionMenu>
  )
}

DataSharing.defaultProps = {}

DataSharing.propTypes = {
  loading: PropTypes.bool,
  isVisible: PropTypes.bool,
  toggleModal: PropTypes.func,
  dataOptions: PropTypes.object,
  balanceOptions: PropTypes.object,
  vcoinsOptions: PropTypes.object,
  transferBalance: PropTypes.func,
  transferData: PropTypes.func,
  transferVcoins: PropTypes.func,
  entryData: PropTypes.object,
  monthlyLimit: PropTypes.object,
  preselectedOption: PropTypes.string,
  confirmationText: PropTypes.object,
  theme: PropTypes.object,
  validatePhoneNumber: PropTypes.func,
  formatPhoneNumber: PropTypes.func,
}

export default withTheme(DataSharing)
